import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
export interface SwitchToLiveDialogData {}

export interface SwitchToLiveOptions {
  deleteManualJobs: boolean;
  deleteManualPoolers: boolean;
  deleteManualDispos: boolean;
  deleteManualEmployments: boolean;
}

@Component({
  selector: 'switch-to-live-dialog',
  templateUrl: 'switch-to-live-dialog.component.html',
  styleUrls: ['switch-to-live-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchToLiveDialogComponent {
  optionsForm = new FormGroup({
    deleteManualJobs: new FormControl(true),
    deleteManualPoolers: new FormControl(true),
    deleteManualDispos: new FormControl(false),
    deleteManualEmployments: new FormControl(true),
  });

  constructor(
    public dialogRef: MatDialogRef<SwitchToLiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SwitchToLiveDialogData,
  ) {}

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    const options: SwitchToLiveOptions = {
      deleteManualJobs: this.optionsForm.value.deleteManualJobs ?? true,
      deleteManualPoolers: this.optionsForm.value.deleteManualPoolers ?? true,
      deleteManualDispos: this.optionsForm.value.deleteManualDispos ?? false,
      deleteManualEmployments:
        this.optionsForm.value.deleteManualEmployments ?? true,
    };
    this.dialogRef.close(options);
  }
}
